export enum UserRoleEnum {
  ADMIN = 'admin',
  VIEWER = 'viewer',
}
